import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type { ComponentProps, ReactNode } from 'react';
import { cn } from '../lib/utils.js';

/** Proveedor unico de tooltips; se monta una vez en la raiz de la aplicacion. */
export function TooltipProvider({
  delayDuration = 300,
  ...props
}: ComponentProps<typeof TooltipPrimitive.Provider>) {
  return <TooltipPrimitive.Provider delayDuration={delayDuration} {...props} />;
}

export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export function TooltipContent({
  className,
  sideOffset = 6,
  ...props
}: ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          'z-50 max-w-xs rounded-md bg-foreground px-2.5 py-1.5 text-xs text-background shadow-raised',
          className,
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
}

export interface SimpleTooltipProps {
  readonly content: ReactNode;
  readonly children: ReactNode;
  readonly side?: ComponentProps<typeof TooltipPrimitive.Content>['side'];
}

/**
 * Atajo para el caso comun: un disparador con un texto descriptivo.
 *
 * @example
 * <SimpleTooltip content="Deshacer (Ctrl+Z)"><IconButton label="Deshacer"><Undo2 /></IconButton></SimpleTooltip>
 */
export function SimpleTooltip({ content, children, side }: SimpleTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent {...(side === undefined ? {} : { side })}>{content}</TooltipContent>
    </Tooltip>
  );
}
